// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1270":"dffa79d8","1789":"c5e9db78","3873":"7daf76f4","5493":"aec40fa4","8634":"7bc452d4"}[chunkId] + ".chunk.css";
};